import { ON_ROUTE_CHANGE } from '../state-constants/stateConstants';

export const onRouteChange = (root) => ({
  type: ON_ROUTE_CHANGE,
  payload: root,
});



// WEBPACK FOOTER //
// ./src/state-actions/onRouteChange.js